//-------------------------------------
//	比較リスト
//	各所で使用できるように、windowのオブジェクトにしておく
//-------------------------------------
var current2_scrollY;

var closeAction = function() {
  window.firstKeep = false;
  $(".side_keep_list, .live_open").removeClass('open');
  $(".side_keep_list-cover").removeClass('open');
  $('.cont-a-foot').removeClass('add');
  // $('.cont-a-foot').attr({style: ''});
  $('body').prop({scrollTop: current2_scrollY});
  scrollEvent();
}

$(function () {
	window.Keep = {
		// 上限件数
		max: 50,

		// 比較リストに入っている作品
		librarys: [],

		// 状態やイベントリスナの初期化処理
		initialize: function (selector) {
			// <label>群
			var $labels = $(selector).find('label.keep');

			// <input type=checkbox>群
			var $checkboxes = $labels.find('input[type=checkbox]');

			// 全て削除ボタン
			var $keepPurgeBtn = $('#keep-purge');

			// <input type=checkbox>と<span>を初期化する
			$labels.each(function () {
				// <label>
				var $this = $(this);

				// <input type=checkbox>
				var $checkbox = $this.find('input[type=checkbox]');

				// <span>
				var $span = $this.find('span');

				// 対象作品のID
				var libraryId = $this.data('library-id');

				// <input type=checkbox>のcheckedを決める値
				var idsArray = $(Keep.librarys).map(function(){
					return this.id;
				}).get();
				var checked = $.inArray(libraryId, idsArray) !== -1;

				// <label>を初期化する
				$this[checked ? 'addClass' : 'removeClass']('on');

				// <input type=checkbox>を初期化する
				$checkbox.prop('checked', checked);
			});

			// <input type=checkbox>の変更に対する処理
			$checkboxes.off('change').on('change', function () {
				// <input type=checkbox>
				var $this = $(this);

				// <label>
				var $label = $this.parent('label');

				// <span>
				var $span = $label.find('span');

				// 対象作品のID
				var libraryId = $label.data('library-id');

				// <input type=checkbox>のchecked
				var checked = $this.prop('checked');

				// 上限件数に達している場合、最も古い作品を削除する
				// その確認ダイアログ
				var confirmRemoveOldestLibrary = function () {
					if (Keep.max <= Keep.librarys.length) {
						var message = '既に' + Keep.max + '件登録されています。最も古い「' + Keep.librarys.pop().title + '」が削除されます。よろしいですか？';

						if (! window.confirm(message)) {
							$this.prop('checked', false);
							return false;
						}
					}

					return true;
				};

				// checked = true の時の処理
				var check = function () {
					Keep.append(libraryId).then(function (response) {
						Keep.librarys = response.librarys;
						$label.addClass('on');
					});
				};

				// checked = false の時の処理
				var uncheck = function () {
					Keep.remove(libraryId).then(function (response) {
						Keep.librarys = response.librarys;
						$label.removeClass('on');
					});
				};

				if (checked) {
					if (confirmRemoveOldestLibrary()) {
						check();
					}
				} else {
					uncheck();
				}
			});

			// 全て削除ボタン押下時の処理
			$keepPurgeBtn.on('click', function() {
				Keep.removeAll();
			});
		},
		append: function (libraryId) {
			var deferred = new $.Deferred();

			$.get('/keep/append/' + libraryId + '/').then(function (response) {
				Keep.librarys = response.librarys;

				$(window).trigger(new $.Event('app.keepLibraryAppended'), {librarys: response.librarys});
				$(window).trigger(new $.Event('app.keepLibraryChanged'), {librarys: response.librarys});

				deferred.resolve(response);
			});

			return deferred.promise();
		},
		remove: function (libraryId) {
			var deferred = new $.Deferred();

			$.get('/keep/remove/' + libraryId + '/').then(function (response) {
				Keep.librarys = response.librarys;

				$(window).trigger(new $.Event('app.keepLibraryRemoved'), {librarys: response.librarys});
				$(window).trigger(new $.Event('app.keepLibraryChanged'), {librarys: response.librarys});

				deferred.resolve(response);
			});

			return deferred.promise();
		},
		removeAll: function (libraryId) {
			var deferred = new $.Deferred();

			$.get('/keep/remove-all/').then(function (response) {
				Keep.librarys = response.librarys;

				$(window).trigger(new $.Event('app.keepLibraryRemoved'), {librarys: response.librarys});
				$(window).trigger(new $.Event('app.keepLibraryChanged'), {librarys: response.librarys});

				deferred.resolve(response);
			});

			return deferred.promise();
		},
		all: function () {
			var deferred = new $.Deferred();

			$.get('/keep/all/').then(function (response) {
				Keep.librarys = response.librarys;

				$(window).trigger(new $.Event('app.keepLibraryFetched'), {librarys: response.librarys});

				deferred.resolve(response);
			});

			return deferred.promise();
		}
	};

	//-------------------------------------
	// 比較リスト取得時、追加時のカウンタ更新
	//-------------------------------------
	$(window).on('app.keepLibraryFetched app.keepLibraryChanged', function (event, params) {
		$('.js-keep-list-count').text(params.librarys.length);
		$('.side_keep_list .ttl .count').text(params.librarys.length + '作品');
		var deferred = new $.Deferred();

		$.get('/api/header-menu/').then(function (response) {
			$('.side_keep_list #keep_slider').html($(response).find('#keep_slider .col'));
			$('.side_keep_list .select_first').replaceWith($(response).find('.select_first'));
			$('.side_keep_list #keep_slider, .side_keep_list .select_first').find("a[rel*='shadowbox']").on('click', function (e) {
				Shadowbox.open(this);
				e.preventDefault()
			});
			Keep.initialize('body');
			// var slideCount = KeepSlider.getSlideCount();
			// var currentSlide = KeepSlider.getCurrentSlide();
			// if (Math.ceil(slideCount / 4) == currentSlide + 1 && Math.ceil(params.librarys.length / 4) < currentSlide + 1) {
			// 	currentSlide = Math.ceil(params.librarys.length / 4);
			// }

			// スライダー化する前に中身の高さ揃え
			$('#keep_slider>.col .vod_info_box').tile(params.librarys.length);

			// KeepSlider.reloadSlider({
			// 	startSlide:currentSlide,
			// 	minSlides: 4,
			// 	maxSlides: 4,
			// 	moveSlides: 4,
			// 	slideWidth: 192,
			// 	hideControlOnEnd: true,
			// 	infiniteLoop: true,
			// 	slideMargin: 8,
			// });
			if (params.librarys.length == 0) {
				$('.side_keep_list .select_none').show();
				$('.side_keep_list .select_first').removeClass('live_open');
				$('.side_keep_list .select_list').removeClass('live_open');
				$('.side_keep_list .select_list').removeClass('open');
				$('.side_keep_list .select_first').removeClass('open');
				$('.side_keep_list').addClass('none_list');
			}else{
				$('.side_keep_list .select_none').hide();
				$('.side_keep_list .select_first').removeClass('live_open');
				$('.side_keep_list .select_list').addClass('live_open');
				$('.side_keep_list').removeClass('none_list');
				$('.side_keep_list').removeClass('first_time');
				if ($('.side_keep_list').hasClass('open')) {
					$('.side_keep_list .select_list').addClass('open');
				}
			}
			if (params.librarys.length == 1) {

				var sideExpire = window.localStorage.getItem('side_expire');
				var time = new Date();
				time.setTime( time.getTime());
				time.toUTCString();
				// 初回リスト追加時
				if (sideExpire < time) {
					var expire = new Date();
					expire.setTime( expire.getTime() + 1000 * 3600 * 24 * 30);
					expire.toUTCString();
					window.localStorage.setItem('side_expire', expire);
					$(".side_keep_list-cover").addClass('open');
					$(".side_keep_list, .select_first").addClass('open');
					$(".side_keep_list .select_first").addClass('live_open');
					$(".side_keep_list-cover").addClass('open');
					$('.side_keep_list .select_list').removeClass('open');
					$('.side_keep_list .select_list').removeClass('live_open');
					$('.side_keep_list').addClass('first_time');
					window.firstKeep = true;
					$('.cont-a-foot').addClass('add');
          current2_scrollY = $(window).scrollTop();
          // $('.cont-a-foot').css({
          //   position: 'fixed',
          //   width: '100%',
          //   top: -1 * current2_scrollY
          // });
          $(window).off('scroll.bindScroll');
				}
			}
			deferred.resolve(response);
		});
	});
	// 初期化
	if((typeof window.Keep === 'object')){
		Keep.all();
	  }
});

/* ############################################################
 * side_keep_list
 * ############################################################*/
$(document).ready(function(){
	var inview = '.js-inview',
		$inview = $(inview);

	$(".btn_side_keep_list_area").on('click',function(){
			$(".side_keep_list, .live_open").toggleClass('open');
			$(".side_keep_list-cover").toggleClass('open');
			$('.cont-a-foot').toggleClass('add');
			if ($('.side_keep_list-cover').hasClass('open')) {
        current2_scrollY = $(window).scrollTop();
				// $('.cont-a-foot').css({
				// 	position: 'fixed',
				// 	width: '100%',
				// 	top: -1 * current2_scrollY
				// });
				$(window).off('scroll.bindScroll');
			}else{
				// $('.cont-a-foot').attr({style: ''});
				$('body').prop({scrollTop: current2_scrollY});
        scrollEvent();
			}
	});

	$('.js-close').on('click', function(e) {
		var target = $(e.target);
		if (target.is('.js-close')) {
		 closeAction();
		}
	});
	$(".btn_close_keep_list").click(function(){
			closeAction();
		});
});



/* ############################################################
 * side_search_word
 * ############################################################*/
$(document).ready(function(){
	var current_scrollY;
	$(".side_search_word_btn").click(function(){
		$("#showSearchWord").toggle(300);
		$('.cont-a-foot').toggleClass('add');
		$(".side_search_word_btn").toggleClass('add');
		$(".btn_side_keep_list_area").css("display","none");
		if ($('.cont-a-foot').hasClass('add')) {
			current_scrollY = $(window).scrollTop();
			$('.cont-a-foot').css({
				position: 'fixed',
				width: '100%',
				top: -1 * current_scrollY,
				padding: '105px 0 0'
			});
		}else{
			$('.cont-a-foot').attr({style: ''});
			$('body').prop({scrollTop: current_scrollY});
		}
	});
	$(".closeWindow").click(function(e){
		window.firstKeep = false;
		$("#showSearchWord").hide(300);
		$('.cont-a-foot').removeClass('add');
		$(".side_search_word_btn").removeClass('add');
		$(".btn_close_keep_list").trigger('click');
		$(".btn_side_keep_list_area").css("display","block");
		if (e.target.tagName.toLowerCase()){
			$('.cont-a-foot').attr({style: ''});
			$('body').prop({scrollTop: current_scrollY});
			$(this).fadeOut();
		}
	});
});


/* ############################################################
 * leanModal
 * ############################################################*/
// var modalExpire = window.localStorage.getItem('modal_expire');
// var time = new Date();
// time.setTime( time.getTime());
// time.toUTCString();
// if ($('.btn_side_keep_list .count').text() == '0' && modalExpire < time && $('#trigger_modal').length) {

// 	var expire = new Date();
// 	expire.setTime( expire.getTime() + 1000 * 3600 * 24 * 30);
// 	expire.toUTCString();
// 	window.localStorage.setItem('modal_expire', expire);
// 	$(window).load(function() {
// 		$("#trigger_modal").leanModal({
// 			top : 150,
// 			left: 0,
// 			width: 100,
// 			overlay : 0.6,
// 			closeButton: ".btn_close"
// 		}).trigger('click');
// 	});
// }

/* ############################################################
 * select_all
 * ############################################################*/
$(function(){
	var genreCheckBoxs = $(".cnt_category_compare input[name='genre[]']");
	var AllGenreCheckBox = $('.cnt_category_compare .check_all input[name=genre_all]');

	AllGenreCheckBox.change(function(){
		checkAllGenreCompare(this, genreCheckBoxs);
	});
	genreCheckBoxs.change(function(){
		checkGenreCompare(genreCheckBoxs, AllGenreCheckBox);
	});
	function checkAllGenreCompare(parent, children){
			children.prop("checked", $(parent).is(':checked'));
	}
	function checkGenreCompare(children, parent){
		if($(children).not(':checked').length != $(children).length){
			parent.prop("checked", false);
		}
	}
	checkAllGenreCompare(AllGenreCheckBox, genreCheckBoxs);

});

/* ############################################################
 * sort
 * ############################################################*/
 $(function(){
	 var sortSelect = $('.cnt_compare_top_list .select_type02	 select[name=sort]');
	 sortSelect.change(function(){
		 if($('#keyword_compare_form input[name=keyword]').val().length > 0){
			 var compareForm = $('#keyword_compare_form');
		 }else{
			 var compareForm = $('#genre_compare_form');
		 }
		 $(compareForm).find('input[name=sort]').val(sortSelect.val());
		 $(compareForm).find('input:submit').trigger('click');
	 });
 });